import DirectionsIcon from "@mui/icons-material/Directions";
import { FormHelperText } from "@mui/material";
import Box from "@mui/material/Box/Box";
import Divider from "@mui/material/Divider/Divider";
import IconButton from "@mui/material/IconButton/IconButton";
import InputBase from "@mui/material/InputBase/InputBase";
import Paper from "@mui/material/Paper/Paper";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Address } from "ton-core";
import { seeIfValidAddress } from "./NewProposal";

export const IndexPage = () => {
  const navigate = useNavigate();
  const [address, setAddress] = useState("");
  const [error, setError] = useState(false);

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (seeIfValidAddress(address)) {
      navigate(`/${Address.parse(address).toString()}`);
    } else {
      setError(true);
    }
  };

  return (
    <Box
      sx={{
        height: "calc(100vh - 200px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 5,
      }}
    >
      <div>
        <Paper
          onSubmit={onSubmit}
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Jetton DAO Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
            <DirectionsIcon />
          </IconButton>
        </Paper>
        {error && (
          <FormHelperText sx={{ mx: "12px" }}>Invalid Address</FormHelperText>
        )}
      </div>
    </Box>
  );
};
